import { render } from "./Widget3.vue?vue&type=template&id=2fd57068"
import script from "./Widget3.vue?vue&type=script&lang=js"
export * from "./Widget3.vue?vue&type=script&lang=js"
script.render = render

export default script